import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import {
  BULK_CAMPAIGNS_RESULT_CLEARED,
  BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL,
  BULK_CAMPAIGNS_RESULT_CREATED,
  BULK_CAMPAIGNS_RESULT_FAILED,
  BULK_CAMPAIGNS_RESULT_TITLE,
} from "../../../i18n/keysTranslations";
import { readArray, translateBulkToken } from "./bulkCampaignModel";

const campaignLabel = (campaign) => {
  if (campaign == null || campaign === "") return "";
  const asNumber = Number(campaign);
  const token = String(campaign).trim();
  if (
    token !== "" &&
    Number.isInteger(asNumber) &&
    String(asNumber) === token
  ) {
    return String(asNumber + 1);
  }
  return String(campaign);
};

const BulkCampaignResult = ({ result }) => {
  const { t } = useTranslationApp();
  const created = readArray(result?.campaignIDs).length;
  const failedCount = result?.failedCount ?? 0;
  const clearedReferences = readArray(result?.clearedReferences);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {t(BULK_CAMPAIGNS_RESULT_TITLE)}
      </Typography>
      <Typography variant="body2">
        {t(BULK_CAMPAIGNS_RESULT_CREATED, { count: created })}
      </Typography>
      <Typography variant="body2">
        {t(BULK_CAMPAIGNS_RESULT_FAILED, { count: failedCount })}
      </Typography>
      {clearedReferences.length > 0 ? (
        <Typography variant="body2">
          {t(BULK_CAMPAIGNS_RESULT_CLEARED, {
            count: clearedReferences.length,
          })}
        </Typography>
      ) : null}
      {clearedReferences.map((item, index) => (
        <Typography
          key={`${item?.field ?? "field"}-${index}`}
          variant="caption"
          color="text.secondary"
        >
          {t(BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL, {
            field: translateBulkToken({
              t,
              token: item?.field,
              prefix: "bulk.field",
            }),
            campaign: campaignLabel(item?.campaign),
          })}
        </Typography>
      ))}
    </Box>
  );
};

export default BulkCampaignResult;
